module.exports = __webpack_public_path__ + "static/media/Dashboard Image.fe7ed462.png";